<script>
import store from './../../store/index.js';
import moment from 'moment'
const { VUE_APP_API_HOST, VUE_APP_VIDEO_API_HOST } = process.env 

function normalizeFileName(name) {
  const [base, ...rest] = name.split('.');
  const ext = rest.length ? '.' + rest.pop() : '';
  const safeBase = base
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9._-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();

  return (safeBase || 'file') + ext.toLowerCase();
}


/**
 * Recursive
 * @param formData 
 * @param data 
 * @param parentKey 
 */
function buildFormData(formData, data, parentKey=undefined) {
  if (data === null || data === undefined) {
    return;
  }

  if (
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    if (Array.isArray(data)) {
      data.forEach((value, index) => {
        const key = parentKey ? `${parentKey}[${index}]` : index;
        buildFormData(formData, value, key);
      });
    } else {
      Object.keys(data).forEach(key => {
        const value = data[key];
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;
        buildFormData(formData, value, fullKey);
      });
    }
  } else {
    formData.append(parentKey, data);
  }
}

function jsonToFormData(json) {
  const fd = new FormData();
  buildFormData(fd, json);
  return fd;
}

function extractValues(srcObj, destObj, values, keyDest) {
  values.forEach((value) => {
    destObj[value] = Object.values(srcObj)[0][value];
  })
  Object.entries(srcObj).forEach(([key, post]) => {
    values.forEach((value) => {
      delete post[value];
    })
    destObj[keyDest][key] = post;
  });
}

export default {
  methods: {
    /**
     * Request headers/params for a music/shop search, aware of the public demo (store
     * `demo/isActive`). In demo mode, sends the demo session header instead of a Bearer token,
     * and appends `&network=` (read from the fake page itself, see store/modules/selectPage.js)
     * so the backend can resolve which real demo page to use - the frontend never sends a real
     * page id (see engine's demoSession.js).
     * @param {string} pageId - the (possibly fake, in demo mode) page id used for this request
     * @returns {{headers: Object, networkParam: string}}
     */
    _demoRequestOptions(pageId) {
      if (!this.$store.getters['demo/isActive']) {
        return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, networkParam: '' }
      }

      const page = this.$store.getters['selectPage/selectPageAllPages'][pageId]
      const network = page && page.network

      return {
        headers: { 'X-Demo-Session': this.$store.getters['demo/sessionToken'] },
        networkParam: network ? `&network=${network}` : ''
      }
    },

    new(post) {
      let formData = new FormData()

      for(let [key, value] of Object.entries(post)){
        if(key == 'data'){
          for(let [subkey, subvalue] of Object.entries(value)){
            if(subkey == 'enclosure' && typeof subvalue == 'object')
              formData.append('file', subvalue)
            else 
              formData.append(`data[${subkey}]`, subvalue)
          }
        } else {
          formData.append(key, value)
        }
      }

      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          timeout: 900000
        })
        .then(res => res, err => err)
    },
    newPost(post) {
      console.log('ici', post)
      let formData = new FormData()
      for(let [key, value] of Object.entries(post)){
        if(key == 'data'){
          for(let [subkey, subvalue] of Object.entries(value)){
            console.log(subkey, subvalue, typeof subvalue);
            if (subkey === 'carrousel' && subvalue) {
              for (let [idx, obj] of subvalue.entries()) {
                console.log("apeend data file", obj.file);
                if (!obj.uploaded) {
                  formData.append(obj.id, obj.file)
                }
              }
              formData.append(`data[${subkey}]`, JSON.stringify(subvalue))
            }
            else if((subkey == 'enclosure' || subkey == 'video' || subkey == 'snippet') && typeof subvalue == 'object') {
              if (subkey == 'snippet') {
                formData.append(`data[${subkey}]`, true)
              }
              formData.append('file', subvalue)
            }
            else if (subkey === 'story_instagram' && subvalue) {
              console.log('subvalue1', subvalue)
              if (subvalue.length === 0) {
                  formData.append(`data[${subkey}]`, 'empty')
              }
              for (let [idx, obj] of subvalue.entries()) {
                console.log(idx, obj)
                for(let [subsubkey, subsubvalue] of Object.entries(obj)){
                  if (subsubkey === 'layers') {
                    for (let [idx2, obj2] of subsubvalue.entries()) {
                      console.log(idx2, obj2)
                      for(let [subsubsubkey, subsubsubvalue] of Object.entries(obj2)){
                          formData.append(`data[${subkey}][${idx}][${subsubkey}][${idx2}][${subsubsubkey}]`, subsubsubvalue);
                      }
                    }
                  } else {
                    formData.append(`data[${subkey}][${idx}][${subsubkey}]`, subsubvalue)
                  }
                }
              }
              
            }
            else 
              formData.append(`data[${subkey}]`, subvalue)
          }
        } else {
          formData.append(key, value)
        }
      }

      console.log('formData', formData)

      // for (let [i,d] of formData.entries()) {
      //   console.log('FORMMMMDARA  ', i, d);
      // }

      this.$http.options.emulateJSON = true;

      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          timeout: 900000
        })
        .then(res => res, err => err)
    },

    events(newsId) {
      return new EventSource(`${VUE_APP_API_HOST}/posts/events?newsId=${newsId}`)
    },

    createAllPosts(posts) {
      console.log('createAllPosts', posts)
      //? TODO Do a unified construction instead?
      let postsData = {
        posts: {}
      };
      extractValues(posts, postsData, ["service", "draft", "allBots", "front_version"], "posts");
      //?
      let formData = jsonToFormData(postsData);
      const pgDraftId = (Object.values(posts)[0] || {}).pgDraftId;
      if (pgDraftId) formData.append('pgDraftId', pgDraftId);

      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/createAll`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          timeout: 900000
        })
    },

    editAllPosts(posts) {
      console.log('editAllPosts', posts)
      //? TODO Do a unified construction instead?
      let postsData = {
        posts: {}
      };
      extractValues(posts, postsData, ["service", "draft", "allBots", "front_version"], "posts");
      //?
      let formData = jsonToFormData(postsData);
      const pgDraftId = (Object.values(posts)[0] || {}).pgDraftId;
      if (pgDraftId) formData.append('pgDraftId', pgDraftId);

      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/editAll`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          timeout: 900000
        })
    },

    newRetweet(post, unretweet=false) {
      let formData = new FormData()

      for(let [key, value] of Object.entries(post)){
        if(key == 'data'){
          for(let [subkey, subvalue] of Object.entries(value)){
            if((subkey == 'enclosure' || subkey == 'video') && typeof subvalue == 'object')
              formData.append('file', subvalue)
            else 
              formData.append(`data[${subkey}]`, subvalue)
          }
        } else {
          formData.append(key, value)
        }
      }

      //this.$http.options.emulateJSON = true;

      return this.$http
        .post(`${VUE_APP_API_HOST}/retweet/`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    newWithoutBot(post) {
      let formData = new FormData()

      for(let [key, value] of Object.entries(post)){
        if(key == 'data'){
          for(let [subkey, subvalue] of Object.entries(value)){
            if(subkey == 'enclosure' && typeof subvalue == 'object')
              formData.append('file', subvalue)
            else 
              formData.append(`data[${subkey}]`, subvalue)
          }
        } else {
          formData.append(key, value)
        }
      }

      return this.$http
        .post(`${VUE_APP_API_HOST}/posts-without-bot/`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },
    newPostWithoutBot(post) {
      let formData = new FormData()

      for(let [key, value] of Object.entries(post)){
        if(key == 'data'){
          for(let [subkey, subvalue] of Object.entries(value)){
            if(subkey == 'enclosure' && typeof subvalue == 'object')
              formData.append('file', subvalue)
            else 
              formData.append(`data[${subkey}]`, subvalue)
          }
        } else {
          formData.append(key, value)
        }
      }

      return this.$http
        .post(`${VUE_APP_API_HOST}/posts-without-bot/`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    getBoardPinterest(page){
        return this.$http
        .get(`${VUE_APP_API_HOST}/posts/board?page=${page.id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)

    },

    getChildsBoardPinterest(page, boardId) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts/board/child?page=${page.id}&board_id=${boardId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    createBoardPinterest(page,boardName, boardId=null){
      console.log('page mixin ' , page, boardName)
       return this.$http
        .post(`${VUE_APP_API_HOST}/posts/board/create?page=${page.id}&boardName=${boardName}${boardId ? `&boardId=${boardId}`: ''}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)

    },

    put(body) {
      const { id } = body
      delete body.id

      return this.$http
        .put(`${VUE_APP_API_HOST}/posts/${id}`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          timeout: 900000
        })
        .then(res => res, err => err)
    },
    putPost(post) {
      console.log('ici', post)
      const { id } = post
      delete post.id
      let formData = new FormData()
      for(let [key, value] of Object.entries(post)){
        if(key == 'data'){
          for(let [subkey, subvalue] of Object.entries(value)){
            console.log(subkey, subvalue);
            if (subkey === 'carrousel' && subvalue) {
              for (let [idx, obj] of subvalue.entries()) {
                console.log("apeend data file", obj);
                if (!obj.ext && !obj.uploaded) {
                  formData.append(obj.id, obj.file)
                }
              }
              formData.append(`data[${subkey}]`, JSON.stringify(subvalue))
            }
            else if((subkey == 'enclosure' || subkey == 'video' || subkey == 'snippet') && typeof subvalue == 'object') {
              if (subkey == 'snippet') {
                formData.append(`data[${subkey}]`, true)
              }
              formData.append('file', subvalue)
            }
            else if (subkey === 'story_instagram' && subvalue) {
              console.log('subvalue1', subvalue)
              if (subvalue.length === 0) {
                  formData.append(`data[${subkey}]`, 'empty')
              }
              for (let [idx, obj] of subvalue.entries()) {
                console.log(idx, obj)
                for(let [subsubkey, subsubvalue] of Object.entries(obj)){
                  if (subsubkey === 'layers') {
                    for (let [idx2, obj2] of subsubvalue.entries()) {
                      console.log(idx2, obj2)
                      for(let [subsubsubkey, subsubsubvalue] of Object.entries(obj2)){
                          formData.append(`data[${subkey}][${idx}][${subsubkey}][${idx2}][${subsubsubkey}]`, subsubsubvalue);
                      }
                    }
                  } else {
                    formData.append(`data[${subkey}][${idx}][${subsubkey}]`, subsubvalue)
                  }
                }
              }
              
            }
            else 
              formData.append(`data[${subkey}]`, subvalue)
          }
        } else {
          formData.append(key, value)
        }
      }

      // for (let [i,d] of formData.entries()) {
      //   console.log('FORMMMMDARA  ', i, d);
      // }

      this.$http.options.emulateJSON = true;

      return this.$http
        .put(`${VUE_APP_API_HOST}/posts/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          },
          timeout: 900000
        })
        .then(res => res, err => err)
    },

    updatePostsMultiPages(posts) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/posts/update/multipages`, { posts }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    updatePostScheduledDate(post, date, all=false, allStorification=false) {
      let user = JSON.parse(localStorage.user)
      return this.$http
        .put(`${VUE_APP_API_HOST}/posts/update/scheduled-date`, { post, date, all, allStorification, user: {id: user.id, name: `${user.firstname} ${user.lastname}`, email: user.email, avatar: user.avatar} }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    delete(post) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/posts?news=${post._id}&bot=${post._bots[0].id}&network=${post._bots[0].page.network}&postId=${post.page[0].post_number || post.page[0].tmp_id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },
    deleteAllPosts(post, all=false) {
      let user = JSON.parse(localStorage.user)
      return this.$http
        .delete(`${VUE_APP_API_HOST}/posts/deleteAll?newsId=${post._id}&bot=${post._bots[0].id}&userId=${user.id}&deleteAll=${all}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },
    deletePost(post, all=false) {
      let user = JSON.parse(localStorage.user)
      let deleteAll = all ? '&deleteAll=true' : '';

      console.log(post);
      let mediaType = null;
      if (post._bots[0].page.network === 'instagram') {
        mediaType = post.page[0].typePost === 'video' && post.page[0].video ? "VIDEO" : (post.page[0].carousel && post.page[0].carousel.length ? "CAROUSEL" : "PHOTO");
      }
      console.log(mediaType);
      
      return this.$http
        .delete(`${VUE_APP_API_HOST}/posts?news=${post.status != 'direct' ? post._id : null}&bot=${post._bots[0].id}&network=${post._bots[0].page.network}&postId=${post.page[0].post_number || post.page[0].tmp_id}&postIdBis=${post.page[0].post_number_bis || ''}&status=${post.page[0].status}&direct=${!!post.page[0].post_number_bis}&userId=${user.id}&mediaType=${mediaType}`+ deleteAll, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },
    postsBy(page, limit, startDate=null , endDate=null, monthly=false) {
      // let periode = startDate && endDate ? `&startDate=${moment(startDate).utc().format()}&endDate=${moment(endDate).utc().format()}&timezone=${VUE_APP_API_HOST == 'http://127.0.0.1:6001' ? 0 : -new Date().getTimezoneOffset()}` : ''
      let periode = startDate && endDate ? `&startDate=${moment(startDate).utc().format()}&endDate=${moment(endDate).utc().format()}&timezone=${-new Date().getTimezoneOffset()}${monthly ? '&monthly=true' : ''}` : ''
      if(monthly)
        periode = `&startDate=${moment(startDate).startOf('month').utc().format()}&endDate=${moment(endDate).endOf('month').utc().format()}&timezone=${-new Date().getTimezoneOffset()}&monthly=true`
     
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts?page=${page}&limit=${limit}${periode}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },
    postsByPagesV2(pages, { statuses, types, search, startDate, endDate, planner, cursor, limit = 50, creator, labels } = {}) {
      const params = new URLSearchParams()
      params.set('pages', pages)
      params.set('limit', limit)
      params.set('timezone', -new Date().getTimezoneOffset())
      if (statuses) params.set('statuses', statuses)
      if (types) params.set('types', types)
      if (search) params.set('search', search)
      if (startDate) params.set('startDate', moment(startDate).startOf('day').utc().format())
      if (endDate) params.set('endDate', moment(endDate).endOf('day').utc().format())
      if (planner) params.set('planner', 'true')
      if (cursor) params.set('cursor', encodeURIComponent(cursor))
      if (creator) params.set('creator', creator)
      if (labels) params.set('labels', labels)

      return this.$http
        .get(`${VUE_APP_API_HOST}/posts/v2?${params.toString()}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
        .then(res => res, err => err)
    },

    postsByPages(pages, limit, startDate=null , endDate=null, monthly=false, allPages=false, v3 = false) {
      // let periode = startDate && endDate ? `&startDate=${moment(startDate).utc().format()}&endDate=${moment(endDate).utc().format()}&timezone=${VUE_APP_API_HOST == 'http://127.0.0.1:6001' ? 0 : -new Date().getTimezoneOffset()}` : ''
      let periode = startDate && endDate ? `&startDate=${moment(startDate).utc().format()}&endDate=${moment(endDate).utc().format()}&timezone=${-new Date().getTimezoneOffset()}${monthly ? '&monthly=true' : ''}` : ''
      if(monthly)
        periode = `&startDate=${moment(startDate).startOf('month').utc().format()}&endDate=${moment(endDate).endOf('month').utc().format()}&timezone=${-new Date().getTimezoneOffset()}&monthly=true`
     
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts?${allPages ? 'allPages=true' : `pages=${pages}`}&limit=${limit}${periode}&v2=true&v3=${v3}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    checkFacebookStatus(newsId, pageId) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/facebook/check-status`, { newsId, pageId }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    postsByPagesPercent(pages, limit, startDate=null , endDate=null, monthly=false, allPages=false) {

      let periode = startDate && endDate ? `&startDate=${moment(startDate).utc().format()}&endDate=${moment(endDate).utc().format()}&timezone=${-new Date().getTimezoneOffset()}${monthly ? '&monthly=true' : ''}` : ''
      if(monthly)
        periode = `&startDate=${moment(startDate).startOf('month').utc().format()}&endDate=${moment(endDate).endOf('month').utc().format()}&timezone=${-new Date().getTimezoneOffset()}&monthly=true`
     
      return new EventSource(`${VUE_APP_API_HOST}/posts?percent=true&token=${encodeURIComponent(localStorage.getItem('token'))}&${allPages ? 'allPages=true' : `pages=${pages}`}&limit=${limit}${periode}&v2=true`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`
                }
              });
    },

    postsByStatus(page, status) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts?page=${page}&status=${status}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    get() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts?status=2`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },
    getPosts() {
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts?status=2&userId=${JSON.parse(localStorage.user).id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },


    findPost(botId, newsId, postId, refreshReporting = false) {
      console.log('findPost', postId)
      const qs = `botId=${botId}&newsId=${newsId}&postId=${encodeURIComponent(postId)}${refreshReporting ? '&refreshReporting=1' : ''}`
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts/find?${qs}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    getPost(botId, newsId) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts/get?botId=${botId}&newsId=${newsId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    affectedUserToPost(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/affected-user`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    
    constructDeepLinkPost(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/construct-deeplink`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    }, 

    search(theme) {
      return VUE_APP_API_HOST + '/posts/search?query=' + theme
    },

    searchPosts(theme, account) {
      return VUE_APP_API_HOST + '/posts/search?query=' + theme + '&account=' + account
    },

    exclude(bot, post) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/posts/exclude?news=${post._id}&bot=${bot}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },
    
    excludeNewsToPost(bot, post) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/posts/exclude?news=${post._id}&bot=${bot}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    async getNewsMeta(url) {

      url = !/^https?:\/\//i.test(url) ? 'https://' +url  : url
    
      try {
          if (!this.$store.getters['postCreator/saveMetaDataUrl'][url]) {
            const response = await this.$http.get(`${VUE_APP_API_HOST}/posts/meta?url=${url}`, {})

            this.$store.commit('postCreator/addMetaDataUrl', {[url] : {
              body : response.body ? response.body : { success : false}
            }});
            
            return response
          }else{
            return this.$store.getters['postCreator/saveMetaDataUrl'][url]
          }
       
      } catch (error) {
        this.$store.commit('postCreator/addMetaDataUrl', {[url] : {
          body : error.body ? error.body : { success : false}
        }});
        return error
      }
    },

    listNewsParsed(feed) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts/list-news?feed=${feed}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },


    getImageFromUrl(url) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/posts/image?url=${url}`, {})
        .then(res => res, err => err)
    },

    addInstagramCredentials(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/pages/instagram/add`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    countInstagramFollowers(pageid) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/followerscount?page=${pageid}`, {})
        .then(res => res, err => err)

    },

   getInstagramPageStatsProfile(pageid) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/pages/followers_count?id=${pageid}`, {})
        .then(res => res, err => err)

    },

    getLinkedinPost(page, post){
      return this.$http
        .get(`${VUE_APP_API_HOST}/linkedin/post?page=${page}&post=${post}`, {})
        .then(res => res, err => err)
    },

    getThreadsPost(page, post){
      return this.$http
        .get(`${VUE_APP_API_HOST}/threads/post?page=${page}&post=${post}`, {})
        .then(res => res, err => err)
    },

    getGooglePost(page, post){
      return this.$http
        .get(`${VUE_APP_API_HOST}/google/post?page=${page}&post=${post}`, {})
        .then(res => res, err => err)
    },

    getSharedPlannerUrl(form) {
      return this.$http
                  .post(
                    `${VUE_APP_API_HOST}/shared-planner-url`,
                    form,
                    {
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                      }
                    }
                  )
                  .then(res => res, err => err)
    },

    getSharedPlanner(key, startDate, endDate) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/shared-planner`, {key, startDate, endDate, timezone: -new Date().getTimezoneOffset()})
        .then(res => res, err => err)
    },

    validateWaitingPost(post, validation, all=false) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/shared-planner/validate`, {
          id: post.id, 
          bot: post._bots[0].id,
          postId: post.page[0].post_number,
          validation,
          status: post.status,
          all
          })
        .then(res => res, err => err)
    },

    removeValidateWaitingPost(post, all=false) {
      let user = JSON.parse(localStorage.user)
      return this.$http
        .delete(`${VUE_APP_API_HOST}/shared-planner/validate?id=${post.id}&bot=${post._bots[0].id}&postId=${post.page[0].post_number}&status=${post.status}&user=${user.id}&all=${all}`, {
          id: post.id, 
          bot: post._bots[0].id,
          postId: post.page[0].post_number,
          status: post.status,
          all
        })
        .then(res => res, err => err)
    },

    addCommentPost(post, comment, all=false) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/shared-planner/comment`, {
          id: post.id, 
          bot: post._bots[0].id,
          postId: post.page[0].post_number,
          comment,
          status: post.status,
          all
          })
        .then(res => res, err => err)
    },

    getInstagramMediaInfo(pageId, mediaId) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/pages/instagram/media/info?id=${pageId}&media=${mediaId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    getLocation(pageId, search) {
      const currentTime = Date.now();
      let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

        return this.$http.get(`${VUE_APP_API_HOST}/posts/location?page=${pageId}&search=${search}&simulate=${needSimulate}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        ).then(res => {
          this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
          return res
        }, 
        err => err)
    },

    getMusicInstagram(pageId, search, feed=undefined) {
        const currentTime = Date.now();
        let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

        const { headers, networkParam } = this._demoRequestOptions(pageId)

        return this.$http.get(`${VUE_APP_API_HOST}/posts/music?page=${pageId}&search=${search}&simulate=${needSimulate}${feed ? '&feed=' + feed : ''}${networkParam}`,{
            headers
          }).then(
            res => {
              this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
              return res
            }, 
            err => err
          )
    },

    getMusicFacebook(pageId, search) {
        const currentTime = Date.now();
        let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

        const { headers, networkParam } = this._demoRequestOptions(pageId)

        return this.$http.get(`${VUE_APP_API_HOST}/posts/facebook/music?page=${pageId}&search=${encodeURIComponent(search || '')}&simulate=${needSimulate}${networkParam}`,{
            headers
          }).then(
            res => {
              this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
              return res
            },
            err => err
          )
    },

    getTrendMusicInstagram(pageId, feed="forYou") {
        const currentTime = Date.now();
        let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

        return this.$http.get(`${VUE_APP_API_HOST}/posts/music-trend?page=${pageId}&simulate=${needSimulate}&topTrends=${feed === "topTrends"}`,{
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }).then(
            res => {
              this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
              return res
            }, 
            err => err
          )
    },

    getMusicTiktok(cursor, region, pageId) {
        return this.$http.get(`${VUE_APP_API_HOST}/posts/tiktok/music-chart?page=${pageId}&cursor=${cursor || 0}&region=${region || 'FR'}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          })
    },

    searchMusicTiktok(keyword, cursor, pageId) {
        const { headers, networkParam } = this._demoRequestOptions(pageId)

        return this.$http.get(`${VUE_APP_API_HOST}/posts/tiktok/music-search?page=${pageId}&keyword=${encodeURIComponent(keyword || '')}&cursor=${cursor || 0}${networkParam}`, {
            headers
          })
    },

    getTrendGifsInstagram(pageId) {
      const currentTime = Date.now();
      let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

      return this.$http.get(`${VUE_APP_API_HOST}/posts/gif-trend?page=${pageId}&simulate=${needSimulate}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      ).then(
          res => {
            this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
            return res
          }, 
          err => err
      )
    },

    searchGifsInstagram(pageId, query) {
      const currentTime = Date.now();
      let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

      return this.$http.get(`${VUE_APP_API_HOST}/posts/gif-search?page=${pageId}&search=${query}&simulate=${needSimulate}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      ).then(
        res => {
          this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
          return res
        }, 
        err => err
      )
    },

    getTrendShopsInstagram(pageId) {
      const currentTime = Date.now();
      let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

      const { headers, networkParam } = this._demoRequestOptions(pageId)

      return this.$http.get(`${VUE_APP_API_HOST}/posts/shop-trend?page=${pageId}&simulate=${needSimulate}${networkParam}`, {
          headers
        }
      ).then(
        res => {
          this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
          return res
        }, 
        err => err
      )
    },

    searchShopsInstagram(pageId, query) {
      const currentTime = Date.now();
      let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

      const { headers, networkParam } = this._demoRequestOptions(pageId)

      return this.$http.get(`${VUE_APP_API_HOST}/posts/shop-search?page=${pageId}&search=${query}&simulate=${needSimulate}${networkParam}`, {
          headers
        }
      ).then(
        res => {
          this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
          return res
        }, 
        err => err
      )
    },

    getTrendItemsShopInstagram(pageId, shopId) {
      const currentTime = Date.now();
      let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

      const { headers, networkParam } = this._demoRequestOptions(pageId)

      return this.$http.get(`${VUE_APP_API_HOST}/posts/itemshop-trend?page=${pageId}&shop=${shopId}&simulate=${needSimulate}${networkParam}`, {
          headers
        }
      ).then(
        res => {
          this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
          return res
        }, 
        err => err
      )
    },

    searchItemsShopInstagram(pageId, shopId, query) {
      const currentTime = Date.now();
      let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

      const { headers, networkParam } = this._demoRequestOptions(pageId)

      return this.$http.get(`${VUE_APP_API_HOST}/posts/itemshop-search?page=${pageId}&search=${query}&shop=${shopId}&simulate=${needSimulate}${networkParam}`, {
          headers
        }
      ).then(
        res => {
          this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
          return res
        }, 
        err => err
      )
    },

    chooseItemShopInstagram(pageId, productId, merchantId) {
      if(!productId || !merchantId) return null
      
      const currentTime = Date.now();
      let needSimulate = !this.$store.getters['postCreator/historySimulateResquest'][pageId] || currentTime - this.$store.getters['postCreator/historySimulateResquest'][pageId] > 600000

      const { headers, networkParam } = this._demoRequestOptions(pageId)

      return this.$http.get(`${VUE_APP_API_HOST}/posts/itemshop-choose?page=${pageId}&product=${productId}&merchant=${merchantId}&simulate=${needSimulate}${networkParam}`, {
          headers
        }
      ).then(
        res => {
          this.$store.commit('postCreator/updateHistorySimulateRequest', {[pageId] : currentTime});
          return res
        }, 
        err => err
      )
    },


    getInstagramPageName(pageId, id) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/posts/instagram/page?page=${pageId}&id=${id}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
    },

    generateTextByAI(text, network=null) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/posts/generate-text?${network ? `network=${network}&` : ''}search=${encodeURI(text)}&locale=${this.$i18n.locale}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
    },

    getTiktokRequirements(bot) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/posts/tiktok-requirements?bot=${bot}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
    },

    getYoutubeCategories(bot, locale) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/posts/youtube-categories?bot=${bot}&locale=${locale}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
    },
    
    getYoutubePlaylists(bot) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/posts/youtube-playlists?bot=${bot}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
    },

    getUploadUrl(fileName, fileType) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/tools/get-upload-url?fileName=${encodeURIComponent(normalizeFileName(fileName))}&fileType=${encodeURIComponent(fileType)}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
    },

    compressImage(url) {
        return this.$http
                   .get(
                     `${VUE_APP_VIDEO_API_HOST}/v2/image/normalize?network=engine-compress&url=${encodeURIComponent(url)}`,
                   )
                   .then(res => res, err => err)
    },

    normalizeImageForNetwork(url, network) {
      return this.$http
        .get(
          `${VUE_APP_VIDEO_API_HOST}/v2/image/normalize?network=${network}&url=${encodeURIComponent(
            url
          )}`
        )
        .then(
          res => res,
          err => err
        )
    },

    getPostsFromRS(page, since, until) {
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/posts/synchronize?page=${page}&since=${since}&until=${until}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
    },

    getInstagramTagsPage(page, cursor = null) {
        const cursorParam = cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''
        return this.$http
                   .get(
                     `${VUE_APP_API_HOST}/posts/instagram-tags?page=${page}${cursorParam}`,
                     {
                       headers: {
                         Authorization: `Bearer ${localStorage.getItem('token')}`
                       }
                     }
                   )
                   .then(res => res, err => err)
    },

    isPostsMultipaged(post) {
        return post.page && post.page[0] && post.page[0].isDraft && post.draft && post.draft.data && post.draft.data.pages ? 
            post.draft.data.pages.length > 1
          : 
            post.page && post.page[0] && post.page[0].posts_multipages && post.page[0].posts_multipages.length > 1
    },

    newLog(postId, log, all=false) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/posts/${postId}/log`, { 
          log,
          all
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    }

   

   /* uploadFile(file) {
      let formData = new FormData()
      formData.append('file', file)

      return this.$http
        .post(`${VUE_APP_API_HOST}/posts/upload/file`, formData, {
          progress(e) {
              if (e.lengthComputable) {
                  console.log(e.loaded / e.total * 100);
              }
          }
        })
        .then(res => res, err => err)
    },*/
  }
}
</script>
